var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOktChain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6026 9H9.40259C9.18168 9 9.00256 9.17904 9.00256 9.39995V14.6C9.00256 14.8209 9.18168 15 9.40259 15H14.6026C14.8235 15 15.0026 14.8209 15.0026 14.6V9.39995C15.0026 9.17904 14.8235 9 14.6026 9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 3H3.40003C3.17912 3 3 3.17904 3 3.40003V8.6C3 8.8209 3.17912 9.00002 3.40003 9.00002H8.6C8.82099 9.00002 9.00002 8.8209 9.00002 8.6V3.40003C9.00002 3.17904 8.82099 3 8.6 3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6001 3H15.4C15.1791 3 15 3.17904 15 3.40003V8.6C15 8.8209 15.1791 9.00002 15.4 9.00002H20.6001C20.821 9.00002 21 8.8209 21 8.6V3.40003C21 3.17904 20.821 3 20.6001 3Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 15H3.40003C3.17912 15 3 15.179 3 15.3999V20.6C3 20.8209 3.17912 21 3.40003 21H8.6C8.82099 21 9.00002 20.8209 9.00002 20.6V15.3999C9.00002 15.179 8.82099 15 8.6 15Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6001 15H15.4C15.1791 15 15 15.179 15 15.3999V20.6C15 20.8209 15.1791 21 15.4 21H20.6001C20.821 21 21 20.8209 21 20.6V15.3999C21 15.179 20.821 15 20.6001 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOktChain);
export default __webpack_public_path__ + "static/media/okt-chain.541125450b8d58467a4456b7fd2c596e.svg";
export { ForwardRef as ReactComponent };